import React from "react"
import QRScanner from "src/pages/dynamic_forms/Utils/QRScanner/QRScanner"
import FieldTypes from "src/pages/dynamic_forms/Types/FieldTypes"
import DynamicFormPaletteTypes from "src/store/DyanmicFormPalette/types"
import TrashCan from "src/pages/dynamic_forms/Utils/TrashCan/TrashCan"
import paletteEngine from "src/pages/dynamic_forms/Utils/paletteEngine"
import Marquee from "react-fast-marquee"
import { OverlayTrigger } from "react-bootstrap"
import mobileFriendlyWarning from "src/pages/dynamic_forms/Utils/MobileFriendlyWarning/MobileFriendlyWarning"
import reoccuringText from "src/pages/dynamic_forms/Utils/ReoccuringText"
import "./ScannerField.css"
import "../../DynamicForm.css"

interface Props {
    manageParentState: Function
    handleChange: Function
    field: FieldTypes
    row: number
    col: number
    formManagerField?: boolean
    configField?: boolean
    templateField?: boolean
    remove: Function
    palette: Array<DynamicFormPaletteTypes>
    readOnly?: boolean
}

function ScannerField(props: Props) {

    // console.log("df_DynamicFormScannerField props", props)

    const field = props.field
    const value = !props.formManagerField ? field.Value : null
    const name = field.Name || "Scanner"
    const templateField = props.templateField
    const formManagerField = props.formManagerField
    const configField = props.configField
    const fieldType = templateField ? "TemplateField" : formManagerField ? "FormMangerField" : configField ? "ConfigField" : "Field"

    const handleChange = (event: { text: string | null }) => {
        props.manageParentState([{ key: "target", value: { row: props.row, col: props.col, key: "Value" } }])
        props.handleChange({ target: { value: event.text } })
    }

    return (
        <div className={`DynamicForm${fieldType} DynamicFormScanner${fieldType}`} style={{ backgroundColor: `${paletteEngine.getPaletteColor("fieldBackgroundColor")}` }}>
            <div className="DynamicFormFieldHeader">
                {!formManagerField && <div className="DynamicFormFieldHeaderLeft">
                    <p style={{ color: `${paletteEngine.getPaletteColor("headerTextColor")}` }}>{name}</p>
                    {field.Required && !field.Value && <span className="material-icons" style={{ color: `${paletteEngine.getPaletteColor("requiredFieldAsteriskColor")}` }}>*</span>}
                </div>}
                <div className="DynamicFormFieldHeaderRight">
                    {templateField && <div className="DynamicFormFieldHeaderRightSettings">
                        <div className="DynamicFormFieldHeaderRightSettingsMultiColumnarWarning">
                            {props.col > 0 &&
                                <OverlayTrigger placement="right" overlay={mobileFriendlyWarning("Rows with multiple columns", reoccuringText.multipleColumnInRowWarningText)}>
                                    <span
                                        className="material-icons"
                                        style={{ color: `${paletteEngine.getPaletteColor("editorConfigMultiColumnsWarningIconColor")}` }}>
                                        priority_high
                                    </span>
                                </OverlayTrigger>}
                        </div>
                        <span className="material-icons DynamicFormFieldHeaderRightSettingsGear"
                            style={{ color: `${paletteEngine.getPaletteColor("editorConfigGearColor")}` }}
                            onClick={() => props.manageParentState([{ key: "configTarget", value: { row: props.row, col: props.col } }])}>
                            settings
                        </span>
                        <TrashCan clickCallback={() => props.remove(field.Type, props.row, props.col, true)} color={`${paletteEngine.getPaletteColor("editorTrashBinColor")}`} />
                    </div>}
                </div>
            </div>
            <div className="DynamicFormFieldBody DynamicFormFieldScannerBody">
                <div className="DynamicFormFieldScannerBodyLeft">
                    <QRScanner
                        manageParentState={props.manageParentState}
                        handleChange={handleChange}
                        closeOnCapture={true}
                        palette={props.palette}
                    />
                </div>
                <div className="DynamicFormFieldScannerBodyMiddle" style={{ backgroundColor: `${paletteEngine.getPaletteColor("fieldInputBackgroundColor")}` }}>
                    {value && <Marquee gradient={false} play={false} pauseOnHover={true}>
                        <p style={{ color: `${paletteEngine.getPaletteColor("fieldInputTextColor")}` }}>{value}</p>
                    </Marquee>}
                </div>
                {value && <div className="DynamicFormFieldScannerBodyRight">
                    <span className="material-icons "
                        onClick={() => handleChange({ text: null })}
                        style={{ color: `${paletteEngine.getPaletteColor("formXIconColor")}` }}>
                        close
                    </span>
                </div>}
            </div>
        </div>
    )
}

export default ScannerField